export const API_BASE_URL = "https://portalapi.theway.org";

/**
 * Timeout period used when checking if the user is logged in.
 * Value is 1 minute in miliseconds.
 */
export const USER_LOGIN_CHECK_TIMEOUT = 1 * 60 * 1000;

/**
 * Grace period used when refreshing the user login.
 * Value is 10 minutes in miliseconds.
 */
export const USER_LOGIN_REFRESH_GRACE = 10 * 60 * 1000;

/**
 * Grace period used when determining if the login is stale.
 * Value is 23 hours in miliseconds.
 */
export const USER_LOGIN_STALE_GRACE = 23 * 60 * 60 * 1000;
